import { useLocation } from "react-router-dom";
import { getType } from "../../actions/studensts";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import StudentList from "../StudentList";
import UNAUTHORIZED from "../UNAUTHORIZED";

export default function AudPend() {
  const studentType = useLocation().pathname.split("/")[3];
  const dispatch = useDispatch();
  const location = useLocation();
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    // Clear students on mount
    dispatch({ type: "CLEAR" });
    
    // Force hasSearched to true for auditing_pending state
    if (studentType === "pending" && !hasSearched) {
      setHasSearched(true);
      return;
    }
    
    // Prevent auto search when URL ends with 'new'
    if (!hasSearched) return;
    
    const state = convertType(studentType);
    console.log('Fetching students with:', {
      type: "auditing",
      state: state,
      search: search,
      studentType: studentType
    });
    
    const timeOutId = setTimeout(
      () => {
        dispatch(getType("auditing", state, search));
      },
      500,
    );
    return () => clearTimeout(timeOutId);
  }, [studentType, location, search, dispatch, hasSearched]);

  // Ensure hasSearched is false on mount (when entering any page)
  useEffect(() => {
    setHasSearched(false);
  }, [location]);
  useEffect(() => {
    if (students) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [students]);

  return (
    <div>
      {!["admin", "auditor", "agent"].includes(user) ? (        <UNAUTHORIZED />
      ) : (
        <div>
          <h1 className="text-2xl pt-0 pl-6 pb-5 text-white">
            {studentType === "new" 
              ? "New In Auditing" 
              : studentType === "pending" 
                ? "Auditing Pending" 
                : "Request Edit"}
          </h1>
          <div className="flex justify-center">
            <div
              className="lg:w-3/5 md:w-3/4 w-full min-h-screen border shadow
          flex flex-col bg-white p-6 rounded-lg"
            >
              <StudentList
                setSearch={(val) => { setSearch(val); setHasSearched(true); }}
                students={students}
                search={search}
                loading={loading}
                count={count}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function convertType(studentType) {
  let state;
  switch (studentType) {
    case "new":
      state = "auditing";
      break;
    case "request_edit":
      state = "request_edit";
      break;
    case "pending":
      state = "auditing_pending";
      break;
    default:
      state = "auditing";
  }
  console.log(`Converting studentType ${studentType} to state ${state}`);
  return state;
}
